export default __webpack_public_path__ + "static/media/twitter-incon__grey.dfcb7335.svg";